import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const WeighingScaleCircularIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 14 14">
      <path
        d="M12.25 0.25H1.75C0.925 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V1.75C13.75 0.925 13.075 0.25 12.25 0.25ZM7 7C5.755 7 4.75 5.995 4.75 4.75C4.75 3.505 5.755 2.5 7 2.5C8.245 2.5 9.25 3.505 9.25 4.75C9.25 5.995 8.245 7 7 7Z"
        fill="#7D8797"
      />
      <path
        d="M5.875 5.125C6.08211 5.125 6.25 4.95711 6.25 4.75C6.25 4.54289 6.08211 4.375 5.875 4.375C5.66789 4.375 5.5 4.54289 5.5 4.75C5.5 4.95711 5.66789 5.125 5.875 5.125Z"
        fill="#7D8797"
      />
      <path
        d="M8.125 5.125C8.33211 5.125 8.5 4.95711 8.5 4.75C8.5 4.54289 8.33211 4.375 8.125 4.375C7.91789 4.375 7.75 4.54289 7.75 4.75C7.75 4.95711 7.91789 5.125 8.125 5.125Z"
        fill="#7D8797"
      />
      <path
        d="M7 5.125C7.20711 5.125 7.375 4.95711 7.375 4.75C7.375 4.54289 7.20711 4.375 7 4.375C6.79289 4.375 6.625 4.54289 6.625 4.75C6.625 4.95711 6.79289 5.125 7 5.125Z"
        fill="#7D8797"
      />
    </SvgIcon>
  );
};
